// SettingsModalPaneHeader.jsx

import React from 'react';

// CSS
import './SettingsModalPaneHeader.css';

/**
 * SettingsModalPaneHeader
 *
 * Shared title row for settings modal panes.
 *
 * @param {string} title - Primary pane heading.
 * @param {string} [subtitle] - Optional secondary line under the title.
 * @param {ReactNode} [rightContent] - Optional trailing actions (buttons, etc.).
 * @param {string} [className] - Optional extra class names for the root element.
 * @param {object} [style] - Optional inline style overrides for the root element.
 *
 * @returns {ReactNode} The rendered pane header.
 */
const SettingsModalPaneHeader = React.memo(({
    title,
    subtitle,
    rightContent,
    className = '',
    style,
}) => (
    <div
      className={['settings-modal-pane-header', className].filter(Boolean).join(' ')}
      style={style}
    >
        <div className="settings-modal-pane-header-left">
            <div className="settings-modal-pane-title">
                {title}
            </div>
            {subtitle ? (
                <div className="settings-modal-pane-subtitle">
                    {subtitle}
                </div>
            ) : null}
        </div>

        {rightContent ? (
            <div className="settings-modal-pane-header-actions">
                {rightContent}
            </div>
        ) : null}
    </div>
));

SettingsModalPaneHeader.displayName = 'SettingsModalPaneHeader';

export default SettingsModalPaneHeader;
